import { SlideOrderForm, type SlideOrderProps } from '../slides/SlideOrderForm';

/** Native carousel product backed by the published post workflow. */
export function PostOrderForm(props: SlideOrderProps) {
  return <SlideOrderForm {...props} kind="post" />;
}
